import $ from 'jquery';
import Cookies from 'js-cookie';

export function setupCookieNoticePopup()
{
	let popup = $('.cookie-notice');
	if( popup.length <= 0 )
	{
		//Cookie popup doesn't exist
		return;
	}

	$('button#button--accept-cookies').on('click', function(e){
		e.preventDefault();
		Cookies.set('cookie-notice', 'set');
		$('.cookie-notice').fadeOut('fast');
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/cookie-notice.js